import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get(
    `kam/states/${options?.countryCode || "IN"}`,
    options,
  );

  return response;
};

export const post = async (state) => {
  const response = await api.post("kam/states", state);

  return response;
};

export const put = async (state) => {
  const response = await api.put("kam/states", state);

  return response;
};
